/**
 * One place for the flush-time guard the PyMOL backend's modules share: a failure in one
 * object (a CIF PyMOL rejects, a wrapper call that throws) is counted and logged and does not
 * stop the others, because Redisplay() is called from all over the app and must not throw.
 */

/**
 * @param {{errors: number}} stats the flush counters
 * @param {string} what e.g. `load _bm_cmp3`, `shapes: pool spheres/1`
 * @param {function} fn
 * @returns {boolean} whether `fn` ran without throwing
 */
export function guarded(stats, what, fn) {
    try {
        fn();
        return true;
    } catch (ex) {
        stats.errors++;
        console.error(`PyMOL backend: ${what} failed`, ex);
        return false;
    }
}
